//eski affiliate linkleri yönlendir
(function () {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');

    if (!ref) return;

    
    if (!/^\d+$/.test(ref)) return;

   
    window.location.replace("/" + ref);
})();